module.exports = __webpack_public_path__ + "static/media/banner_woman_chat_site_br.41be9441.png";